import React from 'react';

/**
 * Column configuration for Search & Select POCs table
 */
export const searchPocsColumns = (selectedPocs = [], allPocs = [], onPocSelect, onSelectAll) => [
  {
    key: 'select',
    header: (
      <input
        type="checkbox"
        checked={allPocs.length > 0 && allPocs.every(poc => selectedPocs.some(p => p.poc_id === poc.poc_id))}
        onChange={(e) => {
          e.stopPropagation();
          onSelectAll && onSelectAll(e.target.checked);
        }}
        className="w-4 h-4 text-blue-600 rounded border-gray-300 focus:ring-blue-500"
        title="Select All"
      />
    ),
    width: '80px',
    headerClassName: 'text-left text-xs font-medium text-gray-700 uppercase tracking-wider',
    cellClassName: 'px-4 py-3',
    render: (value, poc) => {
      const isSelected = selectedPocs.some(p => p.poc_id === poc.poc_id);
      return (
        <input
          type="checkbox"
          checked={isSelected}
          onChange={(e) => {
            e.stopPropagation();
            onPocSelect && onPocSelect(poc);
          }}
          className="w-4 h-4 text-blue-600 rounded border-gray-300 focus:ring-blue-500"
        />
      );
    }
  },
  {
    key: 'poc_id',
    header: 'POC ID',
    width: '150px',
    headerClassName: 'text-left text-xs font-medium text-gray-700 uppercase tracking-wider',
    cellClassName: 'px-4 py-3 text-sm font-mono text-gray-900',
  },
  {
    key: 'poc_name',
    header: 'POC Name',
    headerClassName: 'text-left text-xs font-medium text-gray-700 uppercase tracking-wider',
    cellClassName: 'px-4 py-3 text-sm text-gray-900',
    render: (value) => value || 'N/A'
  },
  {
    key: 'location',
    header: 'Location',
    headerClassName: 'text-left text-xs font-medium text-gray-700 uppercase tracking-wider',
    cellClassName: 'px-4 py-3 text-sm text-gray-500',
    render: (value, poc) => {
      const location = [poc.city, poc.region, poc.country].filter(Boolean).join(', ');
      return location || 'N/A';
    }
  }
];
